import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Table,
} from 'reactstrap';
import KycStatusBadge from './KycStatusBadge';
import { KycStatusLog } from '../models/kycModel';

interface KycStatusLogModalProps {
  isOpen: boolean;
  onClose: () => void;
  logs: KycStatusLog[];
}

const KycStatusLogModal: React.FC<KycStatusLogModalProps> = ({
  isOpen,
  onClose,
  logs,
}) => (
  <Modal isOpen={isOpen} toggle={onClose} centered size="lg">
    <ModalHeader toggle={onClose}>Historial de estados del KYC</ModalHeader>
    <ModalBody>
      <Table responsive>
        <thead>
          <tr>
            <th>Actualizado</th>
            <th>E. anterior</th>
            <th>E. actual</th>
            <th>Usuario</th>
            <th>Comentario</th>
          </tr>
        </thead>
        <tbody>
          {logs && logs.length > 0 ? (
            logs.map((log, idx) => (
              <tr key={idx}>
                <td style={{ fontSize: '0.97rem' }}>{log.update_time}</td>
                <td>
                  <KycStatusBadge status={log.previous_status} />
                </td>
                <td>
                  <KycStatusBadge status={log.current_status} />
                </td>
                <td style={{ fontSize: '0.97rem' }}>
                  {log.updated_by || <span className="text-muted">-</span>}
                </td>
                <td style={{ fontSize: '0.97rem', whiteSpace: 'pre-line' }}>
                  {log.comment || <span className="text-muted">-</span>}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={5} className="text-center text-muted">
                No hay historial de estados.
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </ModalBody>
    <ModalFooter>
      <Button color="secondary" onClick={onClose}>
        Cerrar
      </Button>
    </ModalFooter>
  </Modal>
);

export default KycStatusLogModal;
